import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export const getCategories = async () => {
  try {
    console.log('Fetching categories from Firestore...'); // Debug log
    const configDoc = await getDoc(doc(db, 'config', 'settings'));
    console.log('Config doc exists:', configDoc.exists()); // Debug log
    
    if (configDoc.exists()) {
      const data = configDoc.data();
      console.log('Config data:', data); // Debug log
      return data.categories || [];
    }
    console.log('No config document found'); // Debug log
    return [];
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
};
